import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appImageLoading]',
})
export class ImageLoadingDirective {
  @HostBinding('class.loading') isLoading = true;

  @Output() imageError = new EventEmitter<void>();

  @HostListener('load')
  imageLoaded() {
    this.isLoading = false;
  }

  @HostListener('error')
  imageErrored() {
    this.isLoading = false;
    this.imageError.emit();
    this.imageError.complete();
  }
}
